export const RU = {
  小计: 'Промежуточный итог',
  总计: 'Общий итог',
  总和: '(СУММА)',
  项: 'элемент(-а/-ов)',
  已选择: 'выбрано',
  序号: 'Индекс',
  度量: 'Мера',
  数值: 'Численная величина',
  共计: 'Общее количество',
  条: '',
  隐藏: 'Скрыть',
  趋势: 'Курс',
  组内升序: 'Группировать по возрастанию',
  组内降序: 'Группировать по убыванию',
  升序: 'По возрастанию',
  降序: 'По убыванию',
  不排序: 'Не отсортировано',
  '，': ', ',
};
